module.exports = __webpack_public_path__ + "static/media/img11.fb8135a2.jpg";